import { Component, Input } from '@angular/core';

import { FiltersComponent } from '../../../common/filters.component';
import {
	BankFilters,
	BankOwnersTypes,
	BankOwnersTypesOther,
	CurrentOwnerName,
	TransactionKind,
} from '@/bank/bank.model';

@Component({
	selector: 'app-bank-transactions-filters',
	templateUrl: './bank-transactions-filters.component.html',
	styleUrls: ['./bank-transactions-filters.component.css'],
})
export class BankTransactionsFiltersComponent extends FiltersComponent {
	filters: BankFilters = {
		dateFrom: null,
		dateTo: null,
		currentOwnerName: null,
		type: null,
		objType: null,
		originalDocument: null,
		currentOwnerTransactions: null,
		verified: null,
		calculated: null,
		search: null,
		ownerType: null,
		ownerId: null,
	};
	@Input() types: TransactionKind[] = [];
	@Input() objTypes: BankOwnersTypes[] = [];
	@Input() ownersTypes: BankOwnersTypesOther[] = [];
	@Input() currentOwnerName: CurrentOwnerName[] = [];
}
